<template>
  <div>
    <!-- Add Client MOM Section Start -->
    <div></div>
    <b-button
      v-if="clientID > 0"
      class="mb-1 mt-1"
      @click="openClientMOM(clientID)"
      size="xs"
      style="font-size: 0.675rem"
      >Add MOM</b-button
    >
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="ClientMom-modal"
      hide-footer
      :title="Page_title"
    >
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <b-row>
        <b-col md="3">
          <label>
            Meeting Attendend by Pridel Side
            <span class="error">*</span>
          </label>
          <multi-select
            :options="$store.getters['common/getAllMultiUserList']"
            :selected-options="PridelSideUser_items"
            v-model="clentMomForm.fk_mom_pridel_user_id"
            placeholder="Select Pridel Side User"
            :multiple="true"
            id="fk_mom_pridel_user_id"
            @select="SelectMultiPridelSideUser"
          ></multi-select>
          <span class="error" v-if="!clentMomForm.fk_mom_pridel_user_id">
            {{ errorList.fk_mom_pridel_user_id }}
          </span>
        </b-col>
        <b-col md="3">
          <label>
            Meeting Attendend by Client Side
            <span class="error">*</span>
          </label>
          <multi-select
            :options="$store.getters['common/getAllMultiUserList']"
            :selected-options="ClientSideUser_items"
            v-model="clentMomForm.mom_user"
            placeholder="Select Client Side User"
            :multiple="true"
            id="mom_user"
            @select="SelectMultiClientSideUser"
          ></multi-select>

          <span class="error" v-if="!clentMomForm.mom_user">
            {{ errorList.mom_user }}
          </span>
        </b-col>

        <b-col md="3">
          <label>
            Other Client Side User
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            id="mom_name"
            name="mom_name"
            v-model="clentMomForm.other_mom_user_name"
            placeholder="`Please Enter Other Client User Name"
            type="text"
          ></b-form-input>
          <span class="error" v-if="!clentMomForm.other_mom_user_name">
            {{ errorList.other_mom_user_name }}
          </span>
        </b-col>
        <b-col md="3">
          <label>
            Date Time
            <span class="error">*</span> </label
          ><br />
          <date-picker
            lang="en"
            name="mom_datetime"
            id="mom_datetime"
            type="datetime"
            format="YYYY-MM-DD hh:mm a"
            :minute-step="1"
            v-model="clentMomForm.mom_datetime"
          ></date-picker
          ><br />
          <span class="error" v-if="!clentMomForm.mom_datetime">
            {{ errorList.mom_datetime }}
          </span>
        </b-col>
        <b-col md="3">
          <label>
            Venue
            <span class="error">*</span>
          </label>
          <b-textarea
            :formatter="capitalizeAll"
            id="mom_venue"
            name="mom_venue"
            type="text"
            v-model="clentMomForm.mom_venue"
            placeholder="Please Enter Venue"
          ></b-textarea>
          <span class="error" v-if="!clentMomForm.mom_venue">
            {{ errorList.mom_venue }}
          </span>
        </b-col>
        <b-col md="3">
          <label>
            Further Action
            <span class="error">*</span>
          </label>
          <model-list-select
            :list="furtoreAction"
            id="mom_further_action"
            v-model="clentMomForm.mom_further_action"
            option-value="value"
            option-text="text"
            :placeholder="`Please Select Further Action`"
          ></model-list-select>
          <span class="error" v-if="!clentMomForm.mom_further_action">
            {{ errorList.mom_further_action }}
          </span>
        </b-col>
        <b-col md="3">
          <label>
            Followup Date
            <span class="error">*</span> </label
          ><br />
          <date-picker
            lang="en"
            name="mom_followupdate"
            id="mom_followupdate"
            type="date"
            format="YYYY-MM-DD"
            :minute-step="1"
            v-model="clentMomForm.mom_followupdate"
          ></date-picker
          ><br />
          <span class="error" v-if="!clentMomForm.mom_followupdate">
            {{ errorList.mom_followupdate }}
          </span>
        </b-col>
        <b-col md="3">
          <label>
            Followup Time
            <span class="error">*</span> </label
          ><br />
          <date-picker
            lang="en"
            name="mom_followup_time"
            id="mom_followup_time"
            type="time"
            format="hh:mm a"
            :minute-step="1"
            v-model="clentMomForm.mom_followup_time"
          ></date-picker
          ><br />
          <span class="error" v-if="!clentMomForm.mom_followup_time">
            {{ errorList.mom_followup_time }}
          </span>
        </b-col>
        <div class="col-md-3">
          <label>Assign To</label>
          <multi-select
            :options="$store.getters['common/getAllMultiUserList']"
            :selected-options="AssignedUser_items"
            v-model="clentMomForm.assigned_user"
            placeholder="Select Assign To"
            :multiple="true"
            id="assigned_user"
            @select="SelectMultiAssignedUser"
          ></multi-select>
        </div>
        <b-col md="3">
          <label>
            Remark
            <span class="error"></span>
          </label>
          <b-textarea
            :formatter="capitalizeAll"
            id="mom_remark"
            name="mom_remark"
            type="text"
            v-model="clentMomForm.mom_remark"
            placeholder="Please Enter Remark"
            rows="2"
          ></b-textarea>
          <span class="error" v-if="!clentMomForm.mom_remark">
            {{ errorList.mom_remark }}
          </span>
        </b-col>
        <b-col md="12">
          <label>
            Minutes of Meeting
            <span class="error">*</span>
          </label>
          <quill-editor
            style="
              width: 100% !important;
              height: 300px !important;
              background: #fff;
              display: inline-block;
            "
            :options="editorOptions"
            v-model="clentMomForm.mom_minutes_of_meeting"
          ></quill-editor>
          <!-- <b-textarea
            :formatter="capitalizeAll"
            id="mom_minutes_of_meeting"
            name="mom_minutes_of_meeting"
            type="text"
            v-model="clentMomForm.mom_minutes_of_meeting"
            placeholder="Please Enter Minutes of Meeting"
            rows="5"
          ></b-textarea> -->
          <span class="error" v-if="!clentMomForm.mom_minutes_of_meeting">
            {{ errorList.mom_minutes_of_meeting }}
          </span>
        </b-col>

        <b-col cols="12" class="text-center">
          <b-button
            class="mt-3"
            variant="primary"
            id="saveClientMOM"
            @click="saveClientMOM"
            >Save
          </b-button>
          <b-button class="mt-3" variant="outline-danger" @click="hideClientMOMModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>

  <!-- Add Client MOM Summary Section End -->
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import ClientMomService from "../../services/ClientMomService.js";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },
    PMC_ClientID: {
      type: String,
      default: "",
    },
    PMC_ClientName: {
      type: String,
      default: "",
    },
    PMC_ClientEmail: {
      type: String,
      default: "",
    },
    PMC_ClientPhone: {
      type: String,
      default: "",
    },
    PMC_ClientSeries: {
      type: String,
      default: "",
    },
    PMC_Filter: {
      type: Object,
      default: {},
    },
    PMC_mom_id: {
      type: Number,
      default: 0,
    },
    PMC_mom_Data: {
      type: Object,
      default: {},
    },
  },
  beforeMount() {
    if (this.PMC_ClientID) {
      if (this.PMC_mom_id > 0) {
        this.clentMomForm = {
          fk_client_id: this.PMC_ClientID,
          mom_id: this.PMC_mom_id,
          fk_mom_pridel_user_id: this.PMC_mom_Data.fk_mom_pridel_user_id,
          mom_pridel_user: this.PMC_mom_Data.mom_pridel_user,
          mom_user: this.PMC_mom_Data.mom_user,
          mom_user_txt: this.PMC_mom_Data.mom_user_txt,
          other_mom_user_name: this.PMC_mom_Data.other_mom_user_name,
          mom_venue: this.PMC_mom_Data.mom_venue,
          mom_datetime: this.PMC_mom_Data.mom_datetime,
          mom_minutes_of_meeting: this.PMC_mom_Data.mom_minutes_of_meeting,

          mom_further_action: this.PMC_mom_Data.mom_further_action,
          mom_followupdate: this.PMC_mom_Data.mom_followupdate,
          mom_followup_time: this.PMC_mom_Data.mom_followup_time,
          mom_remark: this.PMC_mom_Data.mom_remark,
          assigned_user: this.PMC_mom_Data.assigned_user,
          assigned_user_txt: this.PMC_mom_Data.assigned_user_txt,
          assigned_user_email: this.PMC_mom_Data.assigned_user_email,
        };
      }
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
      this.$store.dispatch(
        "common/setAllLeadUserList",
        JSON.stringify({
          itemCode: "GET_LEADUSERLIST_Data",
          cleint_id: this.PMC_ClientID,
        })
      );

      this.$store.dispatch(
        "common/setAllMultiUserList",
        JSON.stringify({
          itemCode: "GET_MULTI_USERLIST_Data",
        })
      );
      this.$store.dispatch(
        "common/setAllMultiLeadUserList",
        JSON.stringify({
          itemCode: "GET_MULTI_LEADUSERLIST_Data",
          cleint_id: this.PMC_ClientID,
        })
      );

      // this.saveClientMOM();
    }
  },
  mounted() {},

  data() {
    return {
      Page_title: this.PMC_title,
      clientID: this.PMC_ClientID,
      isLoading: false,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            // [{ header: [1, 2, false] }],
            // ["bold", "italic", "underline"],
            // ["link"],
            // [{ header: 1 }, { header: 2 }], // headers 1 and 2
            // ["blockquote"], // quote
            // ["strike"], // strike
            // ["code-block"], // code block
            // [{ list: "ordered" }, { list: "bullet" }], // ordered and unordered list

            [{ header: "1" }, { header: "2" }], // headers 1 and 2
            ["blockquote", "code-block"], // quote and code block
            ["bold", "italic", "underline", "strike"], // bold, italic, underline, strike
            [{ list: "ordered" }, { list: "bullet" }], // ordered and unordered list
            [{ script: "sub" }, { script: "super" }], // subscript and superscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent and indent
            [{ direction: "rtl" }], // text direction
            [{ size: ["small", false, "large", "huge"] }], // custom font sizes
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
            ["clean"], // remove formatting button
            ["link"],
          ],
        },
      },

      ClientSideUser_items: [],
      PridelSideUser_items: [],
      AssignedUser_items: [],
      minutes_of_meeting_details: [],
      clentMomForm: {
        fk_client_id: this.PMC_ClientID,
        mom_id: "",
        fk_mom_pridel_user_id: "",
        mom_pridel_user: "",
        mom_user: "",
        mom_user_txt: "",
        other_mom_user_name: "",
        mom_venue: "",
        mom_datetime: "",
        mom_minutes_of_meeting: "",

        mom_further_action: "",
        mom_followupdate: "",
        mom_followup_time: "",
        mom_remark: "",
        assigned_user: "",
        assigned_user_txt: "",
        assigned_user_email: "",
      },
      clentMomFormError: [
        "Please Select Pridel Side User",
        "Please Select MOM Side User",
        "Please Enter Venue",
        "Please Enter Date Time",
        "Please Enter Minutes Of Meeting",
        "Please Select Further Action",
        "Please Select Followup Date",
        "Please Select Followup Time",
      ],
      errorList: {
        fk_mom_pridel_user_id: "",
        mom_user: "",
        mom_further_action: "",
        mom_venue: "",
        mom_datetime: "",
        mom_minutes_of_meeting: "",
        // mom_cta: "",
        mom_further_action: "",
        mom_followupdate: "",
        mom_followup_time: "",
        mom_remark: "",
        // assigned_user: "",
      },
      selectDateFormat,
      furtoreAction: [
        {
          text: "CALL",
          value: "CALL",
        },
        {
          text: "EMAIL",
          value: "EMAIL",
        },
        {
          text: "IN PERSON",
          value: "IN PERSON",
        },
      ],
      validate: false,
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    MultiSelect,
  },

  computed: {},
  watch: {},
  methods: {
    SelectMultiPridelSideUser(PridelSideUser_items, lastSelectItem) {
      this.PridelSideUser_items = PridelSideUser_items;
      this.clentMomForm.fk_mom_pridel_user_id = PridelSideUser_items;
      if (PridelSideUser_items.length == 0) {
        this.PridelSideUser_items = [];
        this.clentMomForm.fk_mom_pridel_user_id = "";
      }
      console.log(this.PridelSideUser_items);
    },
    SelectMultiClientSideUser(ClientSideUser_items, lastSelectItem) {
      this.ClientSideUser_items = ClientSideUser_items;
      this.clentMomForm.mom_user = ClientSideUser_items;
      if (ClientSideUser_items.length == 0) {
        this.ClientSideUser_items = [];
        this.clentMomForm.mom_user = "";
      }
    },
    SelectMultiAssignedUser(AssignedUser_items, lastSelectItem) {
      this.AssignedUser_items = AssignedUser_items;
      this.clentMomForm.assigned_user = AssignedUser_items;
      if (AssignedUser_items.length == 0) {
        this.AssignedUser_items = [];
        this.clentMomForm.assigned_user = "";
        this.clentMomForm.assigned_user_email = "";
      }
      console.log(this.AssignedUser_items);
    },
    validateClientMom() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.clentMomForm[x] == "" ||
          this.clentMomForm[x] == undefined ||
          this.clentMomForm[x] == null
        ) {
          this.errorList[x] = this.clentMomFormError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    clearMom() {
      this.ClientSideUser_items = [];
      this.PridelSideUser_items = [];
      this.AssignedUser_items = [];
      this.minutes_of_meeting_details = [];
      this.clentMomForm = {
        fk_client_id: this.PMC_ClientID,
        mom_id: "",
        fk_mom_pridel_user_id: "",
        mom_pridel_user: "",
        mom_user: "",
        mom_user_txt: "",
        other_mom_user_name: "",
        mom_venue: "",
        mom_datetime: "",
        mom_minutes_of_meeting: "",

        mom_further_action: "",
        mom_followupdate: "",
        mom_followup_time: "",
        mom_remark: "",
        assigned_user: "",
        assigned_user_txt: "",
        assigned_user_email: "",
      };
    },

    saveClientMOM() {
      let payload = {};
      this.clentMomForm.fk_mom_pridel_user_id = "";
      this.clentMomForm.mom_pridel_user = "";
      this.clentMomForm.mom_user = "";
      this.clentMomForm.mom_user_txt = "";

      this.clentMomForm.assigned_user = "";
      this.clentMomForm.assigned_user_txt = "";
      this.clentMomForm.assigned_user_email = "";
      if (!this.clentMomForm.fk_mom_pridel_user_id) {
        this.clentMomForm.fk_mom_pridel_user_id = "";
        this.clentMomForm.mom_pridel_user = "";
        this.PridelSideUser_items.forEach((item_val) => {
          if (this.clentMomForm.fk_mom_pridel_user_id) {
            this.clentMomForm.mom_pridel_user =
              this.clentMomForm.mom_pridel_user + "," + item_val.text;
            this.clentMomForm.fk_mom_pridel_user_id =
              this.clentMomForm.fk_mom_pridel_user_id + "," + item_val.value;
          } else {
            this.clentMomForm.mom_pridel_user = item_val.text;
            this.clentMomForm.fk_mom_pridel_user_id = item_val.value;
          }
        });
      }

      if (!this.clentMomForm.mom_user) {
        this.clentMomForm.mom_user = "";
        this.clentMomForm.mom_user_txt = "";
        this.ClientSideUser_items.forEach((item_val) => {
          if (this.clentMomForm.mom_user) {
            this.clentMomForm.mom_user_txt =
              this.clentMomForm.mom_user_txt + "," + item_val.text;
            this.clentMomForm.mom_user =
              this.clentMomForm.mom_user + "," + item_val.value;
          } else {
            this.clentMomForm.mom_user_txt = item_val.text;
            this.clentMomForm.mom_user = item_val.value;
          }
        });
      }

      if (!this.clentMomForm.assigned_user) {
        this.clentMomForm.assigned_user = "";
        this.clentMomForm.assigned_user_txt = "";
        this.AssignedUser_items.forEach((item_val) => {
          if (this.clentMomForm.assigned_user) {
            this.clentMomForm.assigned_user_txt =
              this.clentMomForm.assigned_user_txt + "," + item_val.text;
            this.clentMomForm.assigned_user =
              this.clentMomForm.assigned_user + "," + item_val.value;
            this.clentMomForm.assigned_user_email =
              this.clentMomForm.assigned_user_email + "," + item_val.email;
          } else {
            this.clentMomForm.assigned_user_txt = item_val.text;
            this.clentMomForm.assigned_user = item_val.value;
            this.clentMomForm.assigned_user_email = item_val.email;
          }
        });
      }

      this.validateClientMom();
      if (this.validate == false) return false;
      if (this.clientID) {
        this.isLoading = true;

        payload = {
          itemCode: "upsertClientMOM",
          clientID: this.PMC_ClientID,
          clientName: this.PMC_ClientName,
          clientMomData: this.clentMomForm,
        };

        ClientMomService.getAllClientMomList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.mom_id != "" && data.mom_id != undefined) {
              this.hideClientMOMModal();
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on saveClientMOM Error: ", error);
          });
      }
    },

    openClientMOM(clientID) {
      $(".ql-toolbar").css("display", "block");
      $(".quill-editor").css("overflow", "visible");
      this.$refs["ClientMom-modal"].show();
    },
    hideClientMOMModal() {
      this.clearMom();
      this.$refs["ClientMom-modal"].hide();
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// clientMOM.vue?6cef081e